import React from "react";
import { Link } from "react-router-dom";
import MultipleChoice from "./question_types/multiple-choice";
import ShortAnswer from "./question_types/short-answer";
import Checkboxes from "./question_types/checkboxes";
import Range from "./question_types/range";

import { responseModel, responseDate, responseAnswers, responseOptions } from "./survey-response-model";
const textStyle = { whiteSpace: "pre-wrap", overflowWrap: "anywhere" };

export default function SurveyResponseDetail({ survey, result, onBack, backLabel = "Back to responses", showMessage = false, variant = "results" }) {
  if (!result) return <div className="uk-alert uk-alert-primary" role="status">No survey response available.{onBack && <button type="button" className="uk-button uk-button-text uk-margin-left" onClick={onBack}>{backLabel}</button>}</div>;
  const { definition, context, guestName, questions: ordered, submitted } = responseModel(survey, result);

  return <section aria-label="Survey response detail" className={`uk-margin-top survey-response-detail survey-response-detail-${variant}`}>
    <div className="uk-flex uk-flex-between uk-flex-middle uk-flex-wrap uk-margin-bottom">
      <div>
        {onBack && <button type="button" className="uk-button uk-button-text uk-margin-small-bottom no-print" onClick={onBack}>{backLabel}</button>}
        <h2 className="uk-margin-remove">{definition.name || survey?.name || "Survey response"}</h2>
      </div>
      {showMessage && result.reservation?.thread_id && <Link className="uk-button hms-btn hms-red-btn uk-margin-small-top no-print" to={`/messages/${result.reservation.thread_id}`}>Message {guestName}</Link>}
    </div>
    <div className="uk-margin-bottom uk-margin-large-top">
      <div className="uk-grid-small uk-child-width-1-3@m uk-child-width-1-2@s" data-uk-grid>
        <div><dl className="uk-description-list uk-margin-remove"><dt>Guest</dt><dd style={textStyle}>{guestName}</dd></dl></div>
        <div><dl className="uk-description-list uk-margin-remove"><dt>Property</dt><dd style={textStyle}>{context.property || context.pms_id || "—"}{context.rental_address && <div className="uk-text-meta">{context.rental_address}</div>}</dd></dl></div>
        <div><dl className="uk-description-list uk-margin-remove"><dt>Check-In - Check-Out</dt><dd>{responseDate(context.check_in)} – {responseDate(context.check_out)}</dd></dl></div>
        <div><dl className="uk-description-list uk-margin-remove"><dt>Submitted</dt><dd>{submitted}</dd></dl></div>
      </div>
    </div>
    {definition.intro && <p style={textStyle}>{definition.intro}</p>}
    <div>
      {ordered.map((question, index) => {
        const answers = responseAnswers(result, question.survey_question_id);
        if (!answers.length && !result.definition_snapshot) return null;
        const answer = answers[0] || {};
        const options = responseOptions(question);
        return <div key={`${result.survey_results_id}-${question.survey_question_id}`} className="uk-card uk-card-small uk-card-default hms-property-card">
          <div className="uk-flex uk-flex-between">
            <div className="hms-property-card-body">
              <div className="hms-property-card-content">
                <h4 className="card-heading-small">{question.question}</h4>
                <div className={variant === "guest" ? "hms-small-note" : "secondary"}>{question.help_text}</div>
                {question.question_type === "item-list" ? <>
                  {!answer.value?.items?.length ? <p>No items selected</p> : <ul className="uk-list uk-list-divider">{answer.value.items.map((item) => <li key={item.line_id}>
                    <strong>{item.name}</strong>{item.quantity != null && ` × ${item.quantity}`}{item.unit && ` ${item.unit}`}
                    {item.preference && <div style={textStyle}>{item.preference}</div>}
                  </li>)}</ul>}
                  {answer.value?.notes && <p style={textStyle}>Notes: {answer.value.notes}</p>}
                </> : <>
                <div className="no-print">
                {question.question_type === "multiple-choice" && <MultipleChoice index={`response-${result.survey_results_id}-${index}`} options={options} answer={answer.answer} other={question.include_other && !options.some((option) => option.answer === "Other") ? {} : undefined} />}
                {question.question_type === "short-answer" && <ShortAnswer answer={answer.answer || answer.custom_answer} />}
                {question.question_type === "checkboxes" && <Checkboxes index={`response-${result.survey_results_id}-${index}`} options={options} answer={answers.map((a) => a.answer || a.custom_answer)} other={question.include_other && !options.some((option) => option.answer === "Other") ? {} : undefined} />}
                {/^range-(5|10)$/.test(question.question_type) && <Range question={question} index={`response-${result.survey_results_id}-${index}`} type={Number(question.question_type.split("-")[1])} answer={answer.answer} />}
                {["multiple-choice", "checkboxes"].includes(question.question_type) && answers.filter((a) => a.custom_answer).map((a, i) => <ShortAnswer key={i} answer={a.custom_answer} />)}
                </div>
                <div className="survey-response-print-answer" style={textStyle}>
                  {answers.map((a, i) => <p key={i}>{[a.answer, a.custom_answer].filter((value) => value != null && value !== "").join(" — ") || "Not answered"}</p>)}
                  {!answers.length && <p>Not answered</p>}
                </div>
                </>}
              </div>
            </div>
          </div>
        </div>;
      })}
      {!ordered.length && <p className="uk-text-muted">No answers available.</p>}
    </div>
  </section>;
}
